import { TFunction } from 'i18next';

export function parseOptionalLeadTime(value: string): number | null {
  const normalized = value.trim();
  if (normalized === '') {
    return null;
  }

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : null;
}

export function validateOptionalLeadTime(value: string, t: TFunction) {
  if (value.trim() === '') {
    return true;
  }

  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return t('errors.notValidNumber');
  }

  return parsed >= 0 || t('errors.notNegative');
}
